module.exports = "<div class=\"example\">\n    <img src=\"<%-exampleImg%>\">\n</div>\n<form class=\"form-horizontal\">\n    <div class=\"form-group text-center\">\n        <h4>Click \"save\" to add a signature line for your report.</h4>\n    </div>\n</form>";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/modals/reports/modify_widgets/signaturewidget/signaturewidget.html
// module id = 807
// module chunks = 7